<template lang="html">
  <div class="terminal-operate">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.group')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.terminalEdit')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="operate-container verifone-panel">
      <!-- 第一排，组 start-->
      <div class="group-header">
        <div class="second-item">
          <span>{{$t('message.group')}}：&nbsp;&nbsp;{{groupName}}</span>
        </div>
      </div>
      <!-- 第一排，组 end-->

      <div class="operate-body">
        <!-- APP列表 start -->
        <div class="operate-left">
          <!-- 上半部列表 -->
          <div class="left-upper">
            <div class="left-header">
              <span>{{$t('message.appList')}}</span>
            </div>
            <div class="left-body">
              <el-table ref="singleTable" width="200" highlight-current-row
                @current-change="clickSelected"
                :data="groupApps"
                :max-height="518" :show-header="false">
                <!-- <el-table-column type="selection" width="30" /> -->
                <el-table-column width="50">
                  <template slot-scope="scope">
                    <img class="app-icon" :src="scope.row.icon" alt="">
                  </template>
                </el-table-column>
                <el-table-column width="110" property="showName" />
              </el-table>
            </div>
          </div>
        </div>
        <!-- APP列表 end -->

        <!-- 终端参数列表 start -->
        <div class="operate-right">
          <h4>{{$t('message.terminalLists')}}</h4>
          <div class="table-container">
            <div class="table-main btn-table">
              <template>
                <el-tabs type="card" v-model="parameterTabIndex" class="verifone-tabs" @tab-click="atpTabClick">
                  <el-tab-pane v-for="(item,index) in viewNameList" :label="item" :name="index" :key="index">
                  </el-tab-pane>
                </el-tabs>

              <el-table :data="atpFilterShowList(paramData,atpSelectedTab)" :max-height="500" tooltip-effect="dark" style="width: 100%">
                <el-table-column :label="$t('message.databaseName')">
                  <template slot-scope="scope">{{ scope.row.dataName }}</template>
                </el-table-column>
                <el-table-column prop="value" :label="$t('message.valueEdit')">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.value"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="description" :label="$t('message.description')"></el-table-column>
              </el-table>
              </template>
            </div>
          </div>

          <div class="terminal-footer">
            <span>{{$t('message.totals')}} {{paramData.length}} {{$t('message.items')}}</span>
          </div>

          <!-- 分页 -->
          <div>
            <el-pagination background
              layout="prev, pager, next"
              @current-change="atpPageChange"
              :current-page="atpCurrentPageNum"
              :page-count="atpPageCount" />
          </div>
        </div>
        <!-- 终端参数列表 end -->

      </div>

      <div class="submit-container">
        <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.cancel')}}</el-button>
        <el-button v-if="queryFlag" class="verifone-btn" type="primary" icon="el-icon-document" @click="callSave">{{$t('message.submit')}}</el-button>
        <el-button v-else disabled class="verifone-btn" type="primary" icon="el-icon-document">{{$t('message.submit')}}</el-button>
      </div>
    </div>

    <!-- 是否创建下载任务 Start -->
    <el-dialog :visible.sync="submitDialogVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png">
        <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
      </div>
      <div class="dialog-body">
       <span>{{$t('message.createTaskTipsStart')}}</span><br><div>{{modifyAppDetail}}</div> <span>{{$t('message.createTaskTipsEnd')}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" plain @click="callCreateNo">{{$t('message.no')}}</el-button>
        <el-button class="verifone-btn" type="primary" @click="callCreateDownload">{{$t('message.yes')}}</el-button>
      </span>
    </el-dialog>
    <!-- 是否创建下载任务 End -->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        groupId: null, // 组ID
        groupName: '', // 组名
        currentRow: null, // 当前行数据

        submitDialogVisible: false, // 是否开启提交提示对话框
        selectAppDialogVisible: false, // 是否显示选择应用程序对话框
        queryFlag: false, // 是否有权限标志
        count: 0,

        appSelected: [], // 终端关联的APP列表
        paramData: [], // 选中APP相关参数列表
        viewNameList: [], //tab标签页名集合
        parameterTabIndex: 0, //参数，tab标签页,默认为第一页
        groupApps: [], //组APP集合
        createTaskData: [], // 创建终端参数下载任务的上报数据
        operateTerminalParameterMap: new Map(), // 有经过操作的终端参数

        atpSelectedTab: "", // 当前选中的Tab页Lable值
        atpCurrentPageNum: 1, //当前页码
        atpPageCount: 1, //总页数

        modifyAppDetail:'',//修改的ap的名称和版本

        saveSuccess: this.$t('message.saveSuccess'),
        createSuccess: this.$t('message.createSuccess'),
        inputCheck: this.$t('message.inputCheck'),
        chooseOneApp: this.$t('message.chooseOneApp'),
        tickAPP: this.$t('message.tickAPP'),
        terminalParameterEmpty: this.$t('message.terminalParameterEmpty'),
      }
    },
    mounted() {
      this.init();
      this.setQuery();
      this.queryGroupApps();
    },
    methods: {
      // 初始化数据
      init() {
        this.groupId = this.$route.params.groupId;
        this.groupName = this.$route.params.groupName;
      },

      // 权限校验
      setQuery() {
        let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
        this.queryFlag = !roleArr.includes(41);
      },

      // 获取组App
      queryGroupApps() {
        let that = this,
          obj = {
            groupId: that.groupId
          };
        that.$axios({
          method: 'post',
          url: '/marketplace/app/group',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.groupApps = response.data.groupApps;
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // 退出当前页，到组列表页
      callCreateNo() {
        this.submitDialogVisible = false;
        this.$router.replace('/grouplist');
      },

      // 退出编辑提示
      callBack() {
        if (this.count > 0) {
          this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
            confirmButtonText: this.$i18n.t('message.yes'),
            cancelButtonText: this.$i18n.t('message.no'),
            type: 'warning'
          }).then(() => {
            this.$router.replace('/grouplist');
          })
        } else {
          this.$router.replace('/grouplist');
        }
      },

      // 点击APP图标查看相关参数信息
      clickSelected(newRow, oldRow) {
        let that = this;
        that.currentRow = newRow;

        // 将修改的数据存起来
        if (oldRow != null) {
          let appId = oldRow.id;
          for (let i = 0, j = that.groupApps.length; i < j; i++) {
            if (that.groupApps[i].id == appId){
              that.groupApps[i].parameters = that.paramData;
              that.groupApps[i].viewNameList = that.viewNameList;
            }
          }
          // Map对象 key:appId,value:终端参数集合
          that.operateTerminalParameterMap.set(appId, that.paramData);
        }

        // 如果终端参数存在 就不用去后台取
        if(newRow.parameters != null && newRow.viewNameList != null){
          that.paramData = newRow.parameters;
          that.viewNameList = newRow.viewNameList;
          that.atpSelectedTab = newRow.viewNameList[0];
        }else{
          this.queryParam(newRow.id);
        }

      },

      // 查询终端参数，根据APPID 与 组ID
      queryParam(id) {
        let that = this,
          obj = {
            groupId: that.groupId,
            appId: id
          };
        this.$axios({
          method: 'post',
          url: '/marketplace/groupTerminalParameter/get',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.paramData = response.data.parameters;
            that.viewNameList = response.data.viewNames;
            that.atpSelectedTab = response.data.viewNames[0];
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      //点击保存
      callSave() {
        let that = this,
          obj = {
            groupId: that.groupId,
            dataList: []
          };

        that.operateTerminalParameterMap.set(that.currentRow.id, that.paramData);

        // APP终端参数值非空校验
        let map = that.operateTerminalParameterMap;
        for (let item of map.entries()) {
          let appId = item[0],
            parameters = item[1];
          if(parameters == null || parameters.length <= 0){
            this.$message({
              type: "error",
              message: this.terminalParameterEmpty,
              duration: '3000',
            });
            return;
          }else{
            let data = {
              appId: appId,
              parameterInfoList: parameters
            }
            obj.dataList.push(data);
          }
        }


        this.$axios({
          method: 'post',
          url: '/marketplace/groupTerminalParameter/save',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            this.$message({
              type: "success",
              message: this.saveSuccess,
              duration: '3000',
            });

            if (response.data.parameterChange == 1) {
              that.createTaskData = response.data.dataList;
              that.submitDialogVisible = true;
               for(let i =0,j=response.data.dataList.length;i<j;i++){
                  that.modifyAppDetail=  that.modifyAppDetail +'\n'+ response.data.dataList[i].appName+"-"+response.data.dataList[i].appVersion+'\n' 
                 /* that.modifyAppDetail.push(response.data.dataList[i].appName+"-"+response.data.dataList[i].appVersion+'\n') */
               }
               /* that.modifyAppDetail  = that.modifyAppDetail.substring(0,that.modifyAppDetail.length-1); */
            } else {
              this.$router.replace('/grouplist');
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // 创建下载任务
      callCreateDownload() {
        let obj = {
          dataList: this.createTaskData
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/groupTerminalParameter/task/create',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            this.$message({
              type: "success",
              message: this.createSuccess,
              duration: '3000',
            });

            this.submitDialogVisible = false;
            this.$router.replace('/grouplist');
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      atpFilterShowList(list, label) {
        let temp = this.yyUtils.filterShowList(list,label,this.atpCurrentPageNum);
        this.atpPageCount = temp.pageCount;
        console.log(temp);
        return temp.showList;
      },

      // 终端参数Tabs点击事件
      atpTabClick(tab){
        this.atpCurrentPageNum = 1;
        this.atpSelectedTab = tab.label;
      },

      // 终端参数 页码改变事件
      atpPageChange(currentPageNum){
        this.atpCurrentPageNum = currentPageNum;
        this.atpFilterShowList(this.paramData, this.atpSelectedTab);
      },
    }
  }
</script>

<style lang="css" scoped="scope">
  .operate-container {
    background-color: #fff;
    padding: 15px;
    margin-top: 20px;
    /* min-width: 1060px; */
    overflow: auto;
  }

  .operate-header,
  .operate-body,
  .terminal-footer,
  .left-header {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
  }

  .operate-left {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .operate-header {
    justify-content: flex-start;
    height: 20px;
    align-items: center;
  }

  .operate-body {
    justify-content: center;
    /* height: 100px; */
    padding: 20px;
    with: 100%;
  }

  .terminal-footer {
    padding: 10px;
    justify-content: space-between;
  }

  .terminal-footer span {
    font-size: 14px;
    color: #666;
  }

  .operate-left {
    position: relative;
    width: 20%;
    flex-shrink: 0;
    background-color: #f0f0f0;
  }

  .operate-right {
    width: 80%;
    padding-left: 10px;
  }

  .arrow-left {
    width: 22px;
    height: 22px;
  }

  .sn-container {
    margin-left: 20px;
  }

  .operateSave {
    padding: 6px 18px;
    background-color: #58D56D;
    border: 1px solid #58D56D;
  }

  .app-icon {
    width: 38px;
    height: 38px;
  }

  .left-header {
    padding: 8px 20px;
    justify-content: space-between;
    align-items: center;
  }

  .addApp {
    color: #fff;
    background-color: #58D56D;
    padding: 8px;
  }

  .left-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 10px 0px;
  }

  .delete-icon {
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 24px;
    height: 25px;
    cursor: pointer;
  }

  tr>td {
    padding: 5px 0 !important;
  }

  .el-input__inner {
    border: 1px solid #fff;
  }

  .group-header {
    display: flex;
    flex-direction: row;
    color: #909399;
    font-size: 14px;
  }

  .header-item {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-item span {
    margin-right: 10px;
  }

  .header-item i {
    margin-right: 2px;
  }

  .required-icon {
    color: red;
    font-size: 20px;
  }

  .operate-distance {
    width: 60px;
  }

  .deviceId {
    width: 180px;
  }

  .group-select {
    width: 425px;
  }

  .second-item {
    margin: 10px 5vw 0 20px;
  }

  .trigger-item {
    margin-top: 15px;
  }

  .verifone-tabs {
    padding-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/group/GroupTerminalParameter.vue